module.exports = __webpack_public_path__ + "img/interior-design.c018af68.png";